import { runInAction } from 'mobx';
import { updateMemberLanguageTagPreference } from '../../loyalty/actions/member/update/update-member-language-tag-preference';
import { isMemberSignedIn } from '../../loyalty/selectors/member/is-member-signed-in';
import { sessionDomainStore } from '../store';
export const setLanguageTag = (languageTag, updateMemberPreference = false) => {
    runInAction(() => {
        sessionDomainStore.data.languageTag = languageTag;
    });
    // Only update the member's language preference if there is a signed in member
    if (updateMemberPreference && isMemberSignedIn()) {
        updateMemberLanguageTagPreference(languageTag);
    }
};
//# sourceMappingURL=set-language-tag.js.map